import { Input } from "../../../../components/ui/input";
import { Plus, Upload } from "lucide-react";

/**
 * VendorSkusPanel — Buyer-SKU ↔ Vendor-SKU translation map (Package B).
 * Bulk CSV import + inline edit table. Editor dialog stays in the
 * parent because it lives outside the panel's conditional.
 *
 * Extracted from SellerDropship.jsx in Phase 2 refactor.
 */
export default function VendorSkusPanel({
  skusList, skuDraft, setSkuDraft,
  skusQuery, setSkusQuery,
  saveSkuB, deleteSkuB, loadSkusB,
  importSkusCsvB, skusCsvBusy,
}) {
  return (
  <div className="rounded-2xl border border-border bg-white overflow-hidden" data-testid="fulfillment-skus-panel">
    <div className="px-5 py-3 border-b border-border bg-secondary/40 flex items-center justify-between gap-3 flex-wrap">
      <div>
        <div className="text-[13px] font-medium">Vendor SKU map</div>
        <div className="text-[11px] text-foreground/55 mt-0.5">
          Translate buyer SKUs → your internal SKUs. Used by scan-verify and pack slips.
        </div>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <Input placeholder="Search SKU / product" value={skusQuery}
          onChange={e => setSkusQuery(e.target.value)}
          onBlur={() => loadSkusB(skusQuery)}
          onKeyDown={e => { if (e.key === "Enter") loadSkusB(skusQuery); }}
          data-testid="sku-search" className="h-9 w-56 text-[12.5px]"/>
        <label className="inline-flex items-center gap-1 h-9 px-3 rounded-full text-[11px] mono uppercase tracking-[0.14em] border border-border bg-white hover:bg-secondary cursor-pointer"
          data-testid="sku-csv-btn">
          <Upload className="w-3 h-3"/> {skusCsvBusy ? "Importing…" : "Import CSV"}
          <input type="file" accept=".csv,text/csv" className="hidden"
            data-testid="sku-csv-input"
            onChange={e => { const f = e.target.files?.[0]; e.target.value = ""; if (f) importSkusCsvB(f); }}
            disabled={skusCsvBusy}/>
        </label>
        <button onClick={() => setSkuDraft({ buyer_sku: "", vendor_sku: "", product_name: "" })}
          data-testid="sku-add"
          className="inline-flex items-center gap-1 h-9 px-3 rounded-full text-[11px] mono uppercase tracking-[0.14em] border border-border bg-white hover:bg-secondary">
          <Plus className="w-3 h-3"/> Add mapping
        </button>
      </div>
    </div>
    {skusList.length === 0 ? (
      <div className="p-10 text-center text-[12px] text-foreground/55">
        No mappings yet. CSV columns: <span className="mono">buyer_sku, vendor_sku, product_name</span>.
      </div>
    ) : (
      <table className="w-full text-[12.5px]">
        <thead className="bg-secondary/30 text-[10.5px] mono uppercase tracking-[0.14em] text-foreground/55">
          <tr>
            <th className="text-left px-3 py-2">Buyer SKU</th>
            <th className="text-left px-3 py-2">Vendor SKU</th>
            <th className="text-left px-3 py-2">Product</th>
            <th className="text-right px-3 py-2">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {skusList.map(s => (
            <tr key={s.id} data-testid={`sku-row-${s.id}`}>
              <td className="px-3 py-2 mono">{s.buyer_sku}</td>
              <td className="px-3 py-2 mono">{s.vendor_sku}</td>
              <td className="px-3 py-2 text-foreground/70">{s.product_name || "—"}</td>
              <td className="px-3 py-2 text-right">
                <button onClick={() => setSkuDraft({ ...s })}
                  data-testid={`sku-edit-${s.id}`}
                  className="text-[10.5px] mono uppercase tracking-[0.14em] text-foreground/60 hover:text-foreground underline mr-2">Edit</button>
                <button onClick={() => deleteSkuB(s.id)}
                  data-testid={`sku-delete-${s.id}`}
                  className="text-[10.5px] mono uppercase tracking-[0.14em] text-rose-700 hover:text-rose-900 underline">Remove</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
  );
}
